import { css, sva } from "@stubhub/broadway-foundation/css";

export const trustCardRowText = css({
  flexGrow: "1",
  flexShrink: "0",
  flexBasis: "primitives.0",
});

export const trustCardRecipe = sva({
  slots: ["card", "rows", "row", "icon"],
  className: "trustCard",
  base: {
    card: {
      display: "flex",
      paddingBlock: "primitives.400",
      paddingInline: "primitives.400",
      flexDirection: "column",
      rowGap: "primitives.250",
      alignSelf: "stretch",
      borderStartRadius: "element.default",
      borderEndRadius: "element.default",
      boxShadow: "floating",
      backgroundColor: "bg",
    },
    rows: {
      display: "flex",
      flexDirection: "column",
      rowGap: "primitives.200",
      alignItems: "flex-start",
      alignSelf: "stretch",
    },
    row: {
      display: "flex",
      alignItems: "center",
      columnGap: "primitives.200",
      alignSelf: "stretch",
    },
    icon: {
      display: "flex",
      flexGrow: "0",
      flexShrink: "0",
      flexBasis: "auto",
      paddingBlock: "primitives.25",
      paddingInline: "primitives.25",
      color: "text.info",
    },
  },
});
